import React from 'react';
import {connect} from 'react-redux';
import {compose} from 'redux';
import colors from '../../util/colors';
import * as fonts from '../../util/fonts';
import {createClassName} from '../../util/utility';
import {trackButtonClick} from '../../util/appInsights';
import {useTelemetrySection} from '../../util/TelemetrySection';

import './styles.scss';

export interface AppButtonProps extends React.HTMLProps<HTMLButtonElement> {
  variant?: string;
  style?: any;
  onClick?: any;
  type?: any;
  buStyles?: any;
  backgroundColor?: any;
  telemetryId?: string;
  telemetryLabel?: string;
  telemetrySection?: string;
  telemetryCategory?: string;
  telemetryProperties?: Record<string, any>;
  disableTelemetry?: boolean;
}

function AppButton({
  children,
  className,
  variant,
  style,
  onClick,
  type,
  disabled,
  buStyles,
  backgroundColor,
  telemetryId,
  telemetryLabel,
  telemetrySection,
  telemetryCategory,
  telemetryProperties,
  disableTelemetry,
}: AppButtonProps) {
  let classes = createClassName('app-button', className);
  const contextSection = useTelemetrySection();
  const activeSection = telemetrySection || contextSection;

  const handleClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    if (!disableTelemetry) {
      let label = telemetryLabel;
      if (!label) {
        if (typeof children === 'string' || typeof children === 'number') {
          label = String(children).trim();
        } else if (Array.isArray(children)) {
          label = children
            .filter((c) => typeof c === 'string' || typeof c === 'number')
            .join(' ')
            .trim();
        }
      }

      trackButtonClick(
        label || 'button',
        telemetryCategory,
        telemetryProperties,
        telemetryId,
        activeSection
      );
    }

    if (onClick) {
      onClick(e);
    }
  };

  const color = buStyles?.primaryColor || colors.blue;

  let variantStyle = {
    backgroundColor: color,
    ...fonts.ML,
    fontSize: '17px',
    color: colors.white,
    borderStyle: 'unset',
    borderColor: 'transparent',
  };

  switch (variant) {
    case 'primary':
      variantStyle.color = colors.white;
      break;
    case 'secondary':
      variantStyle.backgroundColor = 'transparent';
      variantStyle.color = color;
      variantStyle.borderStyle = 'solid';
      variantStyle.borderColor = disabled ? colors.lighterGrey : color;
      break;
    case 'inverted':
      variantStyle.backgroundColor = backgroundColor || colors.white;
      variantStyle.color = color;
      break;
    case 'whatsapp':
      variantStyle.backgroundColor = colors.green;
      variantStyle.color = colors.white;
      break;
    case 'chatbot':
      variantStyle.backgroundColor = colors.red;
      variantStyle.color = colors.white;
      break;
    default:
      break;
  }

  return (
    <button
      style={{...variantStyle, ...style}}
      className={classes}
      onClick={handleClick}
      type={type}
      disabled={disabled}>
      {children}
    </button>
  );
}

const mapStateToProps = ({globalStyles}: any) => ({
  buStyles: globalStyles.value,
});

export default compose(connect(mapStateToProps)(AppButton));
